import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SUTransitApprovalDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin'; 
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';

@Component({
  selector: 'app-sm-transit-approval',
  templateUrl: './transit-approval-component.html'
})


export class TransitApprovalComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO:  BaseRequest//= new BaseRequest();
  decision = SUTransitApprovalDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  iSTransitApprovalForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  smallunitRequestObj: SmallUnitRequest = new SmallUnitRequest();
  adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  //@ViewChild('EntranceRequest') EntranceRequest: EntranceRequestComponent;
  @Input() public isShow: boolean = true;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private SmallUnitServ: SmallUnitsServiceFE,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    }else{
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  buildForm(decision) {
    this.iSTransitApprovalForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
      MoreInformation: ['', [Validators.required]],
    });
    // if (decision == SUTransitApprovalDecision.Postpone) {
    //   this.iSTransitApprovalForm = this.formBuilder.group({
    //     Decision: ['', [Validators.required]],
    //     MoreInformation: ['', [Validators.required]],
    //   });
    // }
    // else if   (decision == SUTransitApprovalDecision.Approve) {
    //   this.iSTransitApprovalForm = this.formBuilder.group({
    //     Decision: ['', [Validators.required]],
    //   });
    // }
  }
  changeDecision(value) {
    this.buildForm(value);
    this.iSTransitApprovalForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.iSTransitApprovalForm.controls;
  }

  getBaseRequest() {
    this.SmallUnitServ.get(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.smallunitRequestObj = this.responseObj.Data;
          this.requestStatus = this.smallunitRequestObj.StatusId;
          this.agentId = this.smallunitRequestObj.RequestorId;
          this.isLoaded = true;
          if (history.state.data && history.state.data.isCompleted) {

            this.decisionValue = this.smallunitRequestObj.ISActionId;
            this.buildForm(this.decisionValue);
            this.iSTransitApprovalForm.patchValue({
              Decision: this.smallunitRequestObj.ISActionId,
              MoreInformation: this.smallunitRequestObj.ISNotes
            });
            // if (this.smallunitRequestObj.SmallUnitTransitActionId == SUTransitApprovalDecision.Postpone) {
            //   this.buildForm(this.decisionValue);
            //   this.iSTransitApprovalForm.patchValue({
            //     Decision: this.decisionValue,
            //     MoreInformation: this.smallunitRequestObj.ISNotes
            //   });
            // }
            // else {
            //   this.buildForm(this.decisionValue);
            //   this.iSTransitApprovalForm.patchValue({
            //     Decision:  this.decisionValue,
            //   });
            // }
            this.formMode = FormMode.Readonly;
            this.iSTransitApprovalForm.disable();
          }
        
          else if(this.requestStatus == ServiceStatus.SmallUnit_PendingTransitApproval){
          this.formMode = FormMode.Add;
          this.iSTransitApprovalForm.enable();
          }
          else{
          this.formMode = FormMode.Readonly;
          this.iSTransitApprovalForm.disable();
          this.buildForm(this.decisionValue);
          this.iSTransitApprovalForm.patchValue({
            Decision: this.smallunitRequestObj.ISActionId,
            MoreInformation: this.smallunitRequestObj.ISNotes
          });
          // if (this.smallunitRequestObj.SmallUnitTransitActionId == SUTransitApprovalDecision.Postpone) {
          //   this.buildForm(this.decisionValue);
          //   this.iSTransitApprovalForm.patchValue({
          //     Decision: SUTransitApprovalDecision.Postpone,
          //     MoreInformation: this.smallunitRequestObj.ISNotes
          //   });
          // }
          // else {
          //   this.buildForm(this.decisionValue);
          //   this.iSTransitApprovalForm.patchValue({
          //     Decision: SUTransitApprovalDecision.Approve,
          //   });
          // }

         }
       }
      }    )
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.iSTransitApprovalForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;
    
   // this.adminDecisionObject = this.iSTransitApprovalForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.Id = this.baseRequestId;
    this.adminDecisionObject.ISActionId = this.iSTransitApprovalForm.controls.Decision.value;
    this.adminDecisionObject.ISNotes = this.iSTransitApprovalForm.controls.MoreInformation.value;
    // if (this.adminDecisionObject.ISActionId == SUTransitApprovalDecision.Postpone){
    //   this.adminDecisionObject.ISNotes = this.iSTransitApprovalForm.controls.MoreInformation.value;
    // }
    
    this.SmallUnitAdminServ.TransitApprovalDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.iSTransitApprovalForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
